export const defaultSizingChart = {
  items: [
    {
      id: "maleTopSizingChart",
      sizes: [
        {
          hip: null,
          name: "XS",
          neck: {
            max: 13.5,
            min: 13,
          },
          chest: {
            max: 35,
            min: 33,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 32,
            min: 32,
          },
        },
        {
          hip: null,
          name: "S",
          neck: {
            max: 14.5,
            min: 14,
          },
          chest: {
            max: 38,
            min: 35,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 33.5,
            min: 33,
          },
        },
        {
          hip: null,
          name: "M",
          neck: {
            max: 15.5,
            min: 15,
          },
          chest: {
            max: 41,
            min: 39,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 34.5,
            min: 34,
          },
        },
        {
          hip: null,
          name: "L",
          neck: {
            max: 16.5,
            min: 16,
          },
          chest: {
            max: 44,
            min: 42,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 35.5,
            min: 35,
          },
        },
        {
          hip: null,
          name: "XL",
          neck: {
            max: 17.5,
            min: 17,
          },
          chest: {
            max: 48,
            min: 45,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 36.5,
            min: 36,
          },
        },
        {
          hip: null,
          name: "2XL",
          neck: {
            max: 18,
            min: 17.5,
          },
          chest: {
            max: 52,
            min: 49,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 37.5,
            min: 37,
          },
        },
        {
          hip: null,
          name: "3XL",
          neck: {
            max: 19,
            min: 18.5,
          },
          chest: {
            max: 56,
            min: 53,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 38.5,
            min: 38,
          },
        },
      ],
    },
    {
      id: "femaleTopSizingChart",
      sizes: [
        {
          hip: null,
          name: "XS",
          neck: null,
          chest: {
            max: 32,
            min: 30,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 30,
            min: 29.5,
          },
        },
        {
          hip: null,
          name: "S",
          neck: null,
          chest: {
            max: 35,
            min: 33,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 30,
            min: 29.5,
          },
        },
        {
          hip: null,
          name: "M",
          neck: null,
          chest: {
            max: 38,
            min: 36,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 31.5,
            min: 31,
          },
        },
        {
          hip: null,
          name: "L",
          neck: null,
          chest: {
            max: 41,
            min: 39,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 32.5,
            min: 32,
          },
        },
        {
          hip: null,
          name: "XL",
          neck: null,
          chest: {
            max: 44,
            min: 42,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 33.5,
            min: 33,
          },
        },
        {
          hip: null,
          name: "2XL",
          neck: null,
          chest: {
            max: 47,
            min: 45,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 33.5,
            min: 33,
          },
        },
        {
          hip: null,
          name: "3XL",
          neck: null,
          chest: {
            max: 50,
            min: 48,
          },
          waist: null,
          inseam: null,
          sleeve: {
            max: 44,
            min: 33.5,
          },
        },
      ],
    },
    {
      id: "maleBottomSizingChart",
      sizes: [
        {
          hip: {
            max: 36,
            min: 34,
          },
          name: "XS",
          neck: null,
          chest: null,
          waist: {
            max: 29,
            min: 28,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 38,
            min: 36,
          },
          name: "S",
          neck: null,
          chest: null,
          waist: {
            max: 31,
            min: 30,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 40,
            min: 38,
          },
          name: "M",
          neck: null,
          chest: null,
          waist: {
            max: 33,
            min: 32,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 42,
            min: 40,
          },
          name: "L",
          neck: null,
          chest: null,
          waist: {
            max: 35,
            min: 34,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 44,
            min: 42,
          },
          name: "XL",
          neck: null,
          chest: null,
          waist: {
            max: 37,
            min: 36,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 46,
            min: 44,
          },
          name: "2XL",
          neck: null,
          chest: null,
          waist: {
            max: 39,
            min: 38,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 48,
            min: 46,
          },
          name: "3XL",
          neck: null,
          chest: null,
          waist: {
            max: 41,
            min: 40,
          },
          inseam: null,
          sleeve: null,
        },
      ],
    },
    {
      id: "femaleBottomSizingChart",
      sizes: [
        {
          hip: {
            max: 35,
            min: 33,
          },
          name: "XS",
          neck: null,
          chest: null,
          waist: {
            max: 29,
            min: 28,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 37.5,
            min: 33.5,
          },
          name: "S",
          neck: null,
          chest: null,
          waist: {
            max: 28.5,
            min: 26.5,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 40,
            min: 38,
          },
          name: "M",
          neck: null,
          chest: null,
          waist: {
            max: 33,
            min: 32,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 42,
            min: 40.5,
          },
          name: "L",
          neck: null,
          chest: null,
          waist: {
            max: 33.5,
            min: 31.5,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 36,
            min: 34,
          },
          name: "XL",
          neck: null,
          chest: null,
          waist: {
            max: 45,
            min: 43,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 47.5,
            min: 45.5,
          },
          name: "2XL",
          neck: null,
          chest: null,
          waist: {
            max: 38.5,
            min: 36.5,
          },
          inseam: null,
          sleeve: null,
        },
        {
          hip: {
            max: 50,
            min: 48,
          },
          name: "3XL",
          neck: null,
          chest: null,
          waist: {
            max: 40.5,
            min: 39,
          },
          inseam: null,
          sleeve: null,
        },
      ],
    },
  ],
  unit: "cm",
};
